<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">add</i>
                        </div>
                        <h4 class="card-title ">Novo</h4>
                    </div>
                    <b-form @submit="onSubmit" novalidate="novalidate" autocomplete="off">
                        <div class="card-body">
                            <div class="row">
                                <b-tabs card class="col-lg-12" v-model="tabIndex">
                                    <b-tab title="Dados Básicos da Proposta">
                                        <div class="row">
                                            <div class="col-md-8">
                                                <div class="form-group bmd-form-group is-filled"
                                                     v-bind:class="{'has-danger' : validation.proposal.administrator_id != ''}">
                                                    <label for="administrator_id" class="bmd-label-floating">Administradora <span class="text-danger">*</span></label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="administrators"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.proposal.administrator_id"
                                                        @input="loadGroups">
                                                    </model-list-select>
                                                    <label v-if="validation.proposal.administrator_id != ''" id="administrator_id-error" class="error" for="administrator_id">{{ validation.proposal.administrator_id }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.proposal.physical_proposal != '', 'has-danger' : validation.proposal.physical_proposal != ''}">
                                                    <label form="physical_proposal" class="bmd-label-floating">Número do Contrato <span class="text-danger">*</span></label>
                                                    <input @blur="checkProtocol" type="text" maxlength="20" v-numeric-only class="form-control" v-model="form.proposal.physical_proposal" ref="physical_proposal" />
                                                    <label v-if="validation.proposal.physical_proposal != ''" id="physical_proposal-error" class="error" for="physical_proposal">{{ validation.proposal.physical_proposal }}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </b-tab>
                                    <b-tab title="Dados do Cliente">
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.cpf_cnpj.length > 0, 'has-danger' : validation.client.cpf_cnpj != ''}">
                                                    <label ref="cpf_cnpj" for="cpf_cnpj" class="bmd-label-floating">CPF/CNPJ <span class="text-danger">*</span></label>
                                                    <the-mask type="text" class="form-control" v-model="form.client.cpf_cnpj" v-on:blur.native="searchCpfCnpj" :mask="['###.###.###-##', '##.###.###/####-##']"></the-mask>
                                                    <label v-if="validation.client.cpf_cnpj != ''" id="cpf_cnpj-error" class="error" for="cpf_cnpj">{{ validation.client.cpf_cnpj }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.name != '', 'has-danger' : validation.client.name != ''}">
                                                    <label for="name" class="bmd-label-floating">Nome <span class="text-danger">*</span></label>
                                                    <input ref="name" type="text" class="form-control" v-model="form.client.name" />
                                                    <label v-if="validation.client.name != ''" id="name-error" class="error" for="name">{{ validation.client.name }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-4"
                                                v-if="form.client.cpf_cnpj.length <= 11">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.mother_name != ''}">
                                                    <label for="mother_name" class="bmd-label-floating">Nome da mãe</label>
                                                    <input ref="mother_name" type="text" class="form-control" v-model="form.client.mother_name" />
                                                </div>
                                            </div>
                                        </div>
                                        <br />
                                        <br />
                                        <h5 v-if="form.client.cpf_cnpj.length <= 11" class="info-text">
                                            RG
                                        </h5>
                                        <h5 v-else class="info-text">
                                            Insc. Estadual
                                        </h5>
                                        <hr />
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.registration_number != ''}">
                                                    <label for="registration_number" class="bmd-label-floating">Número </label>
                                                    <input ref="registration_number" v-numeric-only type="text" class="form-control" v-model="form.client.registration_number" />
                                                    <label for="registration_number">{{ validation.client.registration_number }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.dispatcher_registration_number != ''}">
                                                    <label for="dispatcher_registration_number" class="bmd-label-floating">Orgão Emissor</label>
                                                    <input ref="dispatcher_registration_number" type="text" class="form-control" v-model="form.client.dispatcher_registration_number" />
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group is-filled" >
                                                    <label for="shipment_date_registration_number" class="bmd-label-floating">Expedição </label>
                                                    <date-picker v-model="form.client.shipment_date_registration_number" lang="pt-br" format="DD/MM/YYYY" placeholder="Escolha uma data" :not-after="new Date()"></date-picker>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="form.client.cpf_cnpj.length <= 11" class="row">
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.nationality != ''}">
                                                    <label for="nationality" class="bmd-label-floating">Nacionalidade</label>
                                                    <input ref="nationality" type="text" class="form-control" v-model="form.client.nationality" />
                                                    <label v-if="validation.client.nationality != ''" id="nationality-error" class="error" for="nationality">{{ validation.client.nationality }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.naturality != ''}">
                                                    <label for="naturality" class="bmd-label-floating">Naturalidade</label>
                                                    <input ref="naturality" type="text" class="form-control" v-model="form.client.naturality" />
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="profession" class="bmd-label-floating">Estado Civil</label>
                                                    <model-select :options="marital_status"
                                                        v-model="form.client.marital_status">
                                                    </model-select>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="profession" class="bmd-label-floating">Sexo</label>
                                                    <model-select :options="sexes"
                                                        v-model="form.client.sex">
                                                    </model-select>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="equity_value" class="bmd-label-floating">Valor do Patrimônio</label>
                                                    <money v-model="form.client.equity_value" maxlength="13" class="form-control" v-bind="money" placeholder=""></money>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.client.date_of_birth != ''}">
                                                    <label v-if="form.client.cpf_cnpj.length <= 11" for="date_of_birth" class="bmd-label-floating">Nascimento</label>
                                                    <label v-else for="date_of_birth" class="bmd-label-floating">Abertura</label>
                                                    <date-picker v-model="form.client.date_of_birth" lang="pt-br" format="DD/MM/YYYY" placeholder="Escolha uma data" :not-after="new Date()"></date-picker>
                                                    <label v-if="validation.client.date_of_birth != ''" id="date_of_birth-error" class="error" for="date_of_birth">{{ validation.client.date_of_birth }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row ">
                                            <div class="col-md-2">
                                                <div class="form-check bmd-form-group is-filled">
                                                    <label class="bmd-label-floating">Autoriza divulgar dados?</label>
                                                    <b-form-checkbox
                                                        id="authorize_disseminate_data"
                                                        v-model="form.client.authorize_disseminate_data"
                                                        :value="true"
                                                        :unchecked-value="false">
                                                        {{ form.client.authorize_disseminate_data ? 'Sim': 'Não' }}
                                                    </b-form-checkbox>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-check bmd-form-group is-filled">
                                                    <label class="bmd-label-floating">Pessoa politicamente exposta?</label>
                                                    <b-form-checkbox
                                                        id="pessoa_politicamente_exposta"
                                                        v-model="form.client.pessoa_politicamente_exposta"
                                                        :value="true"
                                                        :unchecked-value="false">
                                                        {{ form.client.pessoa_politicamente_exposta ? 'Sim': 'Não' }}
                                                    </b-form-checkbox>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-check bmd-form-group is-filled">
                                                    <label class="bmd-label-floating">Possui capacidade econômica/financeira?</label>
                                                    <b-form-checkbox
                                                        id="possui_capacidade_economica_financeira"
                                                        v-model="form.client.possui_capacidade_economica_financeira"
                                                        :value="true"
                                                        :unchecked-value="false">
                                                        {{ form.client.possui_capacidade_economica_financeira ? 'Sim': 'Não' }}
                                                    </b-form-checkbox>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-check bmd-form-group is-filled">
                                                    <label class="bmd-label-floating">Reconhece assinatua presente na proposta?</label>
                                                    <b-form-checkbox
                                                        id="reconhece_assinatura_presente_proposta"
                                                        v-model="form.client.reconhece_assinatura_presente_proposta"
                                                        :value="true"
                                                        :unchecked-value="false">
                                                        {{ form.client.reconhece_assinatura_presente_proposta ? 'Sim': 'Não' }}
                                                    </b-form-checkbox>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-check bmd-form-group is-filled">
                                                    <label class="bmd-label-floating">Não recebi promessa de contemplação?</label>
                                                    <b-form-checkbox
                                                        id="nao_recebeu_promessa_contemplacao"
                                                        v-model="form.client.nao_recebeu_promessa_contemplacao"
                                                        :value="true"
                                                        :unchecked-value="false">
                                                        {{ form.client.nao_recebeu_promessa_contemplacao ? 'Sim': 'Não' }}
                                                    </b-form-checkbox>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-check bmd-form-group is-filled">
                                                    <label class="bmd-label-floating">Informar eventuais alterações?</label>
                                                    <b-form-checkbox
                                                        id="ciencia_informar_alteracoes_afins"
                                                        v-model="form.client.ciencia_informar_alteracoes_afins"
                                                        :value="true"
                                                        :unchecked-value="false">
                                                        {{ form.client.ciencia_informar_alteracoes_afins ? 'Sim': 'Não' }}
                                                    </b-form-checkbox>
                                                </div>
                                            </div>
                                        </div>
                                        <div id="pessoa-fisica" v-if="form.client.cpf_cnpj.length <= 11">
                                            <br />
                                            <br />
                                            <h5 class="info-text">
                                                Dados Profissionais
                                            </h5>
                                            <hr />
                                            <div class="row">
                                                <div class="col-md-4">
                                                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.company_name != ''}">
                                                        <label for="company_name" class="bmd-label-floating">Nome da Empresa</label>
                                                        <input ref="company_name" type="text" class="form-control" v-model="form.client.company_name" />
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.profession != ''}">
                                                        <label for="profession" class="bmd-label-floating">Profissão</label>
                                                        <input ref="profession" type="text" class="form-control" v-model="form.client.profession" />
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form-group bmd-form-group is-filled">
                                                        <label for="salary" class="bmd-label-floating">Salário</label>
                                                        <money v-model="form.client.salary" maxlength="13" class="form-control" v-bind="money" placeholder=""></money>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div id="pessoa-juridica" v-else>
                                            <br />
                                            <br />
                                            <h5 class="info-text">
                                                Dados Empresariais
                                            </h5>
                                            <hr />
                                            <div class="row">
                                                <div class="col-md-4">
                                                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.activity_name != ''}">
                                                        <label for="activity_name" class="bmd-label-floating">Atividade da Empresa</label>
                                                        <input ref="activity_name" type="text" class="form-control" v-model="form.client.activity_name" />
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form-group bmd-form-group is-filled">
                                                        <label for="monthly_billing" class="bmd-label-floating">Faturamento Mensal</label>
                                                        <money v-model="form.client.monthly_billing" maxlength="13" class="form-control" v-bind="money" placeholder=""></money>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form-group bmd-form-group is-filled">
                                                        <label for="equity_value" class="bmd-label-floating">Valor do Patrimônio</label>
                                                        <money v-model="form.client.equity_value" maxlength="13" class="form-control" v-bind="money" placeholder=""></money>
                                                    </div>
                                                </div>
                                            </div>
                                            <br />
                                            <h6 class="info-text">
                                                Sócios <b-button right variant="success" @click="addPartner()">Adicionar</b-button>
                                            </h6>
                                            <div class="row"
                                                v-for="(partner, key) in form.client.partners">
                                                <div class="col-md-3">
                                                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': partner.name != ''}">
                                                        <label v-bind:for="'partner_name_' + key" class="bmd-label-floating">Nome</label>
                                                        <input v-bind:ref="'partner_name_' + key" type="text" class="form-control" v-model="partner.name" />
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': partner.cpf_cnpj != ''}">
                                                        <label v-bind:for="'partner_name_' + key" class="bmd-label-floating">CPF/CNPJ</label>
                                                        <the-mask type="text" class="form-control" v-model="partner.cpf_cnpj" :mask="['###.###.###-##', '##.###.###/####-##']"></the-mask>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group bmd-form-group is-filled">
                                                        <label v-bind:for="'participation' + key" class="bmd-label-floating">Participação (%)</label>
                                                        <money v-model="partner.participation" maxlength="6" class="form-control" v-bind="percent" placeholder=""></money>
                                                    </div>
                                                </div>
                                                <div class="col-md-3" v-if="key > 0">
                                                    <b-button
                                                        block
                                                        variant="danger"
                                                        @click="removePartner(partner)"
                                                        >Remover</b-button>
                                                </div>
                                            </div>
                                        </div>
                                        <br />
                                        <br />
                                        <h5 class="info-text">
                                            Dados de Contato
                                        </h5>
                                        <hr />
                                        <div class="row">
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.mail != ''}">
                                                    <label for="mail" class="bmd-label-floating">E-mail <span class="text-danger">*</span></label>
                                                    <input ref="mail" type="mail" class="form-control" v-model="form.client.mail" />
                                                    <label v-if="validation.client.mail != ''" id="mail-error" class="error" for="mail">{{ validation.client.mail }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.cell_phone != ''}">
                                                    <label for="cell_phone" class="bmd-label-floating">Telefone Celular <span class="text-danger">*</span></label>
                                                    <the-mask @blur.native="checkPhoneLead" ref="cell_phone" type="text" class="form-control" v-model="form.client.cell_phone" :mask="['(##) #####-####', '(##) #####-####']"></the-mask>
                                                    <label v-if="validation.client.cell_phone != ''" id="cell_phone-error" class="error" for="cell_phone">{{ validation.client.cell_phone }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.home_phone != ''}">
                                                    <label for="home_phone" class="bmd-label-floating">Telefone Residencial</label>
                                                    <the-mask ref="home_phone" type="text" class="form-control" v-model="form.client.home_phone" :mask="['(##) ####-####']"></the-mask>
                                                    <label v-if="validation.client.home_phone != ''" id="home_phone-error" class="error" for="home_phone">{{ validation.client.home_phone }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.commercial_phone != ''}">
                                                    <label for="commercial_phone" class="bmd-label-floating">Telefone Comercial</label>
                                                    <the-mask ref="commercial_phone" type="text" class="form-control" v-model="form.client.commercial_phone" :mask="['(##) ####-####']"></the-mask>
                                                    <label v-if="validation.client.commercial_phone != ''" id="commercial_phone-error" class="error" for="commercial_phone">{{ validation.client.commercial_phone }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <br />
                                        <br />
                                        <h5 class="info-text">
                                            Dados Bancários
                                        </h5>
                                        <hr />
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="bank_id" class="bmd-label-floating">Banco</label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="banks"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.client.bank_id"
                                                        placeholder="Escolha um banco">
                                                    </model-list-select>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="row">
                                                    <div class="col-md-9">
                                                        <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.bank_branch != '' || form.client.bank_digit_branch != ''}">
                                                            <label for="bank_branch" class="bmd-label-floating">Agência</label>
                                                            <input ref="bank_branch" type="text" v-numeric-only class="form-control" v-model="form.client.bank_branch"></input>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <div class="form-group bmd-form-group">
                                                            <input ref="bank_digit_branch" maxlength="5" type="text" class="form-control" v-model="form.client.bank_digit_branch"></input>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="row">
                                                    <div class="col-md-9">
                                                        <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.account_number != '' || form.client.account_digit != ''}">
                                                            <label for="account_number" class="bmd-label-floating">Número da conta</label>
                                                            <input ref="account_number" type="text" v-numeric-only class="form-control" v-model="form.client.account_number"></input>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <div class="form-group bmd-form-group">
                                                            <input ref="account_digit" maxlength="5" type="text" class="form-control" v-model="form.client.account_digit"></input>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <br />
                                        <br />
                                        <h5 class="info-text">
                                            Endereço
                                        </h5>
                                        <hr />
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.address.cep != ''}">
                                                    <label for="cep" class="bmd-label-floating">CEP <span class="text-danger">*</span></label>
                                                    <the-mask ref="cep" type="text" class="form-control" v-model="form.address.cep" v-on:blur.native="searchCep" :mask="'##.###-###'" />
                                                    <label v-if="validation.address.cep != ''" id="address-error" class="error" for="address">{{ validation.address.cep }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.address.address != ''}">
                                                    <label for="address" class="bmd-label-floating">Endereço</label>
                                                    <input ref="address" type="text" class="form-control" v-model="form.address.address" />
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.address.number != ''}">
                                                    <label for="number" class="bmd-label-floating">Número</label>
                                                    <input ref="number" type="text" maxlength="15" class="form-control" v-model="form.address.number" />
                                                    <label v-if="validation.address.number != ''" id="number-error" class="error" for="number">{{ validation.address.number }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.address.borough != '', 'has-danger' : validation.address.borough != ''}">
                                                    <label for="borough" class="bmd-label-floating">Bairro <span class="text-danger">*</span></label>
                                                    <input ref="borough" type="text" class="form-control" v-model="form.address.borough" />
                                                    <label v-if="validation.address.borough != ''" id="borough-error" class="error" for="borough">{{ validation.address.borough }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.address.complement != ''}">
                                                    <label for="complement" class="bmd-label-floating">Complemento</label>
                                                    <input ref="complement" type="text" class="form-control" v-model="form.address.complement" />
                                                    <label v-if="validation.address.complement != ''" id="complement-error" class="error" for="complement">{{ validation.address.complement }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group is-filled"
                                                     v-bind:class="{'has-danger': validation.address.city.state.id != ''}">
                                                    <label for="state" class="bmd-label-floating">Estado <span class="text-danger">*</span></label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="states"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.address.city.state.id"
                                                        @input="onSelectState">
                                                    </model-list-select>
                                                    <label v-if="validation.address.city.state.id != ''" id="complement-error" class="error" for="complement">{{ validation.address.city.state.id }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group is-filled"
                                                     v-bind:class="{'has-danger': validation.address.city.id != ''}">
                                                    <label for="city" class="bmd-label-floating">Cidade <span class="text-danger">*</span></label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="cities"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.address.city.id">
                                                    </model-list-select>
                                                    <label v-if="validation.address.city.id != ''" id="complement-error" class="error" for="complement">{{ validation.address.city.id }}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </b-tab>
                                    <b-tab title="Dados da Proposta">
                                        <div class="row">
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.proposal.physical_proposal != ''}">
                                                    <label form="physical_proposal" class="bmd-label-floating">Número do Contrato</label>
                                                    <input type="text" maxlength="20" v-numeric-only class="form-control" v-model="form.proposal.physical_proposal" readonly="" />
                                                </div>
                                            </div>

                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.proposal.protocol != ''}">
                                                    <label form="protocol" class="bmd-label-floating">Protocolo <!--span class="text-danger">*</span--></label>
                                                    <input ref="protocol" type="text" maxlength="20" v-numeric-only class="form-control" v-model="form.proposal.protocol" />
                                                    <label v-if="validation.protocol != ''" id="protocol-error" class="error" for="physical_proposal">{{ validation.proposal.protocol }}</label>
                                                </div>
                                            </div>

                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.proposal.type_sale_id != ''}">
                                                    <label form="physical_proposal" class="bmd-label-floating">Tipo de venda <!--span class="text-danger">*</span--></label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="type_sales"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.proposal.type_sale_id"
                                                        placeholder="Não definido">
                                                    </model-list-select>
                                                </div>
                                            </div>

                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.proposal.protocol != ''}">
                                                    <label form="physical_proposal" class="bmd-label-floating">Indicador de ficha<!--span class="text-danger">*</span--></label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="users"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.proposal.user_indicate_id"
                                                        placeholder="Não possui">
                                                    </model-list-select>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="partner_name" class="bmd-label-floating">Nome do Parceiro</label>
                                                    <input refs="partner_name" type="text" class="form-control" v-model="form.partner_name" />
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="partner_code" class="bmd-label-floating">Código do Parceiro</label>
                                                    <input refs="partner_code" type="text" class="form-control" v-model="form.partner_code" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row" v-if="!salesman">
                                            <div class="col-md-1">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <h5>Lead?</h5>
                                                    <div class="togglebutton">
                                                        <label>
                                                            <input type="checkbox" v-model="form.proposal.lead" value="0" disabled />
                                                            <span class="toggle"></span>
                                                            <b>{{form.proposal.yn_lead}}</b>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="media_id" class="bmd-label-floating">Origem</label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="medias"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.proposal.media_id"
                                                        placeholder="Escolha a origem">
                                                    </model-list-select>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="team_id" class="bmd-label-floating">Equipes</label>
                                                    <model-list-select
                                                        :isDisabled="phoneFromLead"
                                                        class="form-control"
                                                        :list="teams"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.proposal.team_id"
                                                        @input="changeTeam">
                                                    </model-list-select>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled"
                                                     v-bind:class="{'has-danger' : validation.proposal.salesman_id != ''}">
                                                    <label for="salesmans" class="bmd-label-floating">Vendedor <span class="text-danger">*</span></label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :isDisabled="phoneFromLead"
                                                        :list="salesmans"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.proposal.salesman_id">
                                                    </model-list-select>
                                                    <label v-if="validation.proposal.salesman_id != ''" id="salesman_id-error" class="error" for="salesman_id">{{ validation.proposal.salesman_id }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <hr v-if="!salesman" />
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="administrator_show" class="bmd-label-floating">Administradora</label>
                                                    <input type="text" class="form-control" v-model="administrator" readonly="" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="option_plan" class="bmd-label-floating">Opção para Plano Simples</label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="optionPlans"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.proposal.option_plan"
                                                        placeholder="Não especificado">
                                                    </model-list-select>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="plan_id" class="bmd-label-floating">Plano </label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="plans"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.proposal.plan_id"
                                                        placeholder="Não especificado">
                                                    </model-list-select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group is-filled"
                                                     v-bind:class="{'has-danger' : validation.proposal.type_group_id != ''}">
                                                    <label for="type_group_id" class="bmd-label-floating">Tipo do Grupo <span class="text-danger">*</span></label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="type_groups"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.proposal.type_group_id"
                                                        @input="loadGroups">
                                                    </model-list-select>
                                                    <label v-if="validation.proposal.type_group_id != ''" id="type_group_id-error" class="error" for="type_group_id">{{ validation.proposal.type_group_id }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group is-filled"
                                                     v-bind:class="{'has-danger' : validation.proposal.group_id != ''}">
                                                    <label for="group_id" class="bmd-label-floating">Grupo</label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="groups"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.proposal.group_id"
                                                        @input="setMeetingAt(form.proposal.group_id)">
                                                    </model-list-select>
                                                    <label v-if="validation.proposal.group_id != ''" id="group_id-error" class="error" for="group_id">{{ validation.proposal.group_id }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group is-filled"
                                                     v-bind:class="{'has-danger' : validation.proposal.meeting_at != ''}">
                                                    <label form="meeting_at" title="Data da próxima assembléia" class="bmd-label-floating">Data da Próxima Assembléia <span class="text-danger">*</span></label>
                                                    <input ref="meeting_at" type="date" readonly class="form-control text-center" v-model="form.proposal.meeting_at" />
                                                    <label v-if="validation.proposal.meeting_at != ''" id="meeting_at-error" class="error" for="meeting_at">{{ validation.proposal.meeting_at }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group is-filled"
                                                     v-bind:class="{'has-danger' : validation.proposal.first_meeting_at != ''}">
                                                    <label form="first_meeting_at" title="Data da PRIMEIRA ASSEMBLÉIA" class="bmd-label-floating">Data da PRIMEIRA ASSEMBLÉIA</label>
                                                    <date-picker style="width:95%" v-model="form.proposal.first_meeting_at" title="Data da primeira assembléia" lang="pt-br" format="DD/MM/YYYY" placeholder="Escolha uma data"></date-picker>
                                                    <label v-if="validation.proposal.first_meeting_at != ''" id="meeting_at-error" class="error" for="first_meeting_at">{{ validation.proposal.first_meeting_at }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-1">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.proposal.quota != ''}">
                                                    <label form="quota" class="bmd-label-floating">Cota (9999.9)</label>
                                                    <input ref="quota" type="text" v-numeric-only class="form-control" v-model="form.proposal.quota" />
                                                    <label v-if="validation.proposal.quota != ''" id="quota-error" class="error" for="quota">{{ validation.proposal.quota }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.meeting_number != ''}">
                                                    <label form="meeting_number" class="bmd-label-floating">Assembleia de Participação (Nº)</label>
                                                    <input refs="meeting_number" type="text" class="form-control" v-model="form.meeting_number" />
                                                </div>
                                            </div>
                                            <div class="col-md-1">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.quota_deadline != ''}">
                                                    <label form="quota_deadline" class="bmd-label-floating">Prazo Cota</label>
                                                    <input refs="quota_deadline" type="text" class="form-control" v-model="form.quota_deadline" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled"
                                                     v-bind:class="{'has-danger' : validation.proposal.manufacturer_id != ''}">
                                                    <label for="manufacturer_id" class="bmd-label-floating">Marca/Categoria <span class="text-danger">*</span></label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="manufacturers"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.proposal.model.manufacturer_id"
                                                        @input="getDataModels">
                                                    </model-list-select>
                                                    <label v-if="validation.proposal.manufacturer_id != ''" id="manufacturer_id-error" class="error" for="manufacturer_id">{{ validation.proposal.manufacturer_id }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled"
                                                     v-bind:class="{'has-danger' : validation.proposal.model_id != ''}">
                                                    <label for="model_id" class="bmd-label-floating">Modelo/Bem <span class="text-danger">*</span></label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="models"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.proposal.model_id">
                                                    </model-list-select>
                                                    <label v-if="validation.proposal.model_id != ''" id="model_id-error" class="error" for="model_id">{{ validation.proposal.model_id }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="fuel_id" class="bmd-label-floating">Combustível</label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="fuels"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.proposal.fuel_id">
                                                    </model-list-select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.proposal.reason_acquisition != ''}">
                                                    <label form="reason_acquisition" class="bmd-label-floating">Motivo da Aquisição</label>
                                                    <input ref="reason_acquisition" type="text" class="form-control" v-model="form.proposal.reason_acquisition" />
                                                    <label v-if="validation.proposal.reason_acquisition != ''" id="reason_acquisition-error" class="error" for="reason_acquisition">{{ validation.proposal.reason_acquisition }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="condition" class="bmd-label-floating">Condição</label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="conditions"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.proposal.condition">
                                                    </model-list-select>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="formation" class="bmd-label-floating">Formação</label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="formations"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.proposal.formation">
                                                    </model-list-select>
                                                </div>
                                            </div>
                                        </div>
                                        <hr />
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label form="administrate_tax" class="bmd-label-floating">Taxa Administrativa (%)</label>
                                                    <money v-model="form.proposal.administrate_tax" maxlength="6" class="form-control" v-bind="percent" placeholder=""></money>
                                                    <label v-if="validation.proposal.administrate_tax != ''" id="administrate_tax-error" class="error" for="administrate_tax">{{ validation.proposal.administrate_tax }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="life_insurance" class="bmd-label-floating">Seguro de Vida (%)</label>
                                                    <money v-model="form.proposal.life_insurance" maxlength="6" class="form-control" v-bind="percent" placeholder=""></money>
                                                    <label v-if="validation.proposal.life_insurance != ''" id="life_insurance-error" class="error" for="life_insurance">{{ validation.proposal.life_insurance }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="reserve_fund" class="bmd-label-floating">Fundo de Reserva (%)</label>
                                                    <money v-model="form.proposal.reserve_fund" maxlength="6" class="form-control" v-bind="percent" placeholder=""></money>
                                                    <label v-if="validation.proposal.reserve_fund != ''" id="reserve_fund-error" class="error" for="reserve_fund">{{ validation.proposal.reserve_fund }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-check bmd-form-group is-filled">
                                                    <label form="first_payment_in_billet" class="bmd-label-floating">Recibo da 1ª Parcela via boleto?</label>
                                                    <b-form-checkbox
                                                        id="first_payment_in_billet"
                                                        v-model="form.first_payment_in_billet"
                                                        :value="true"
                                                        :unchecked-value="false">
                                                        {{ form.first_payment_in_billet ? 'Sim': 'Não' }}
                                                    </b-form-checkbox>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label form="first_payment_value" class="bmd-label-floating">Valor recebido da 1ª Parcela</label>
                                                    <money v-model="form.first_payment_value" maxlength="12" class="form-control" v-bind="money" placeholder=""></money>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label form="first_payment_value" class="bmd-label-floating">Data do recebimento da 1ª Parcela</label>
                                                    <date-picker v-model="form.first_payment_at" lang="pt-br" format="DD/MM/YYYY" placeholder="Escolha uma data"></date-picker>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label form="diluted_fee_percentage" class="bmd-label-floating">Taxa Antecipada Diluída (% em parcelas)</label>
                                                    <money v-model="form.diluted_fee_percentage" maxlength="6" class="form-control" v-bind="percent" placeholder=""></money>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label form="installment_fee_percentage" class="bmd-label-floating">Taxa Antecipada Parcelada (%)</label>
                                                    <money v-model="form.installment_fee_percentage" maxlength="6" class="form-control" v-bind="percent" placeholder=""></money>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group is-filled"
                                                     v-bind:class="{'has-danger' : validation.proposal.value != ''}">
                                                    <label form="value" class="bmd-label-floating">Valor da Carta (R$) <span class="text-danger">*</span></label>
                                                    <money v-model="form.proposal.value" maxlength="13" class="form-control" v-bind="money" placeholder=""></money>
                                                    <label v-if="validation.proposal.value != ''" id="value-error" class="error" for="value">{{ validation.proposal.value }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group is-filled"
                                                     v-bind:class="{'has-danger' : validation.proposal.plot_amount != ''}">
                                                    <label for="plot_amount" class="bmd-label-floating">Valor da Parcela (R$) <span class="text-danger">*</span></label>
                                                    <money v-model="form.proposal.plot_amount" maxlength="13" class="form-control" v-bind="money" placeholder=""></money>
                                                    <label v-if="validation.proposal.plot_amount != ''" id="plot_amount-error" class="error" for="plot_amount">{{ validation.proposal.plot_amount }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group is-filled"
                                                     v-bind:class="{'has-danger' : validation.proposal.number_installments != ''}">
                                                    <label for="number_installments" class="bmd-label-floating">Quant. Parcelas <span class="text-danger">*</span></label>
                                                    <money v-model="form.proposal.number_installments" maxlength="3" class="form-control" v-bind="integer" placeholder=""></money>
                                                    <label v-if="validation.proposal.number_installments != ''" id="number_installments-error" class="error" for="number_installments">{{ validation.proposal.number_installments }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group is-filled"
                                                     v-bind:class="{'has-danger' : validation.proposal.installment_due != ''}">
                                                    <label form="installment_due" class="bmd-label-floating">Data de Vencimento da Parcela <span class="text-danger">*</span></label>
                                                    <date-picker v-model="form.proposal.installment_due" lang="pt-br" format="DD/MM/YYYY" placeholder="Escolha uma data"></date-picker>
                                                    <label v-if="validation.proposal.installment_due != ''" id="installment_due-error" class="error" for="installment_due">{{ validation.proposal.installment_due }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <hr />
                                        <div class="row">
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group is-filled"
                                                     v-bind:class="{'has-danger' : validation.proposal.sale_at != ''}">
                                                    <label form="sale_at" class="bmd-label-floating">Data da Venda <span class="text-danger">*</span></label>
                                                    <date-picker v-model="form.proposal.sale_at" lang="pt-br" format="DD/MM/YYYY" placeholder="Escolha uma data"></date-picker>
                                                    <label v-if="validation.proposal.sale_at != ''" id="sale_at-error" class="error" for="sale_at">{{ validation.proposal.sale_at }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group is-filled"
                                                     v-bind:class="{'has-danger' : validation.proposal.deployment_at != ''}">
                                                    <label form="deployment_at" class="bmd-label-floating">Data Alocação</label>
                                                    <date-picker v-model="form.proposal.deployment_at" lang="pt-br" format="DD/MM/YYYY" placeholder="Escolha uma data"></date-picker>
                                                    <label v-if="validation.proposal.deployment_at != ''" id="deployment_at-error" class="error" for="deployment_at">{{ validation.proposal.deployment_at }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group bmd-form-group is-filled"
                                                     v-bind:class="{'has-danger' : validation.proposal.type_payment_id != ''}">
                                                    <label for="type_of_payments" class="bmd-label-floating">Tipos de Pagamento <span class="text-danger">*</span></label>
                                                    <b-form-group id="type_of_payments">
                                                        <b-form-checkbox
                                                            v-for="type_of_payment in type_of_payments"
                                                            v-model="form.proposal.type_payment_id"
                                                            :key="type_of_payment.id"
                                                            :value="type_of_payment.id"
                                                            >
                                                            {{ type_of_payment.name }}
                                                        </b-form-checkbox>
                                                    </b-form-group>
                                                    <label v-if="validation.proposal.type_payment_id != ''" id="type_payment_id-error" class="error" for="type_payment_id">{{ validation.proposal.type_payment_id }}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </b-tab>
                                    <b-tab title="Documentos">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <upload-documents v-model="documents" :items="[]" :upload="true" />
                                            </div>
                                        </div>
                                    </b-tab>
                                </b-tabs>
                            </div>
                        </div>
                        <div class="card-footer">
                            <form-buttons
                                v-bind:toBackAuto="true" />
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ClientService from '@/services/modules/clients.service';
    import DefaultService from '@/services/modules/defaults.service';
    import GroupService from '@/services/modules/groups.service';
    import UserService from '@/services/modules/users.service';
    import JwtService from '@/services/jwt.service';
    import Validation from '@/services/validations.service';
    import UploadDocuments from '@/components/elements/UploadDocuments';
    const max_number_installments = 400;

    export default {
        components: {
            'upload-documents': UploadDocuments
        },
        computed: {
            administrators: {
                set(_administrators) {

                },
                get() {
                    return this.$store.state.administrators.itens;
                }
            },
            banks: {
                set(_banks) {

                },
                get() {
                    return this.$store.state.defaults.banks;
                }
            },
            fuels: {
                set(_fuels) {

                },
                get() {
                    return this.$store.state.fuels.itens;
                }
            },
            manufacturers: {
                set(_manufacturers) {

                },
                get() {
                    return this.$store.state.manufacturers.itens;
                }
            },
            medias: {
                set(_medias) {

                },
                get() {
                    return this.$store.state.medias.itens;
                }
            },
            models: {
                set(_models) {

                },
                get() {
                    return this.$store.state.models.itens;
                }
            },
            plans: {
                set(_plans) {

                },
                get() {
                    return this.$store.state.plans.itens;
                }
            },
            states: {
                set(_states) {

                },
                get() {
                    return this.$store.state.defaults.states;
                }
            },
            teams: {
                set(_teams) {

                },
                get() {
                    return this.$store.state.teams.itens;
                }
            },
            type_of_payments: {
                set(_typeOfPayments) {

                },
                get() {
                    return this.$store.state.type_of_payments.itens;
                }
            },
            type_sales: {
                set(_typeSales) {},
                get() {
                    return this.$store.state.type_sales.items;
                }
            },
            users: {
                set(_users) { },
                get() {
                    return this.$store.state.users.itens;
                }
            },
            leads: {
                set(_leads) { },
                get() {
                    return this.$store.state.lead;
                }
            }
        },
        data() {
            return {
                administrator: null,
                answers: [
                    {value: '', text: 'Selecione uma opção'},
                    {value: true, text: 'Sim'},
                    {value: false, text: 'Não'},
                ],
                cities: [],
                clientState: '',
                conditions: [
                    {id: 'Nova', name: 'Venda Nova'},
                    {id: 'Subs', name: 'Substituição'}
                ],
                documents: [],
                files: [],
                phoneFromLead: false,
                form: {
                    address: {
                        address: '',
                        cep: '',
                        number: '',
                        complement: '',
                        borough: '',
                        city: {
                            id: '',
                            state: {
                                id: ''
                            }
                        }
                    },
                    protocol: '',
                    user_indicate_id: '',
                    type_sale_id: '',
                    client: {
                        cpf_cnpj: '',
                        name: '',
                        registration_number: '',
                        dispatcher_registration_number: '',
                        shipment_date_registration_number: '',
                        nationality: '',
                        marital_status: '',
                        profession: '',
                        sex: '',
                        date_of_birth: '',
                        authorize_disseminate_data: '',
                        mail: '',
                        cell_phone: '',
                        home_phone: '',
                        commercial_phone: '',
                        bank_digit_branch: '',
                        bank_branch: '',
                        account_number: '',
                        account_digit: '',
                        naturality: '',
                        mother_name: '',
                        company_name: '',
                        salary: 0,
                        equity_value: 0,
                        pessoa_politicamente_exposta: false,
                        possui_capacidade_economica_financeira: false,
                        reconhece_assinatura_presente_proposta: false,
                        nao_recebeu_promessa_contemplacao: false,
                        ciencia_informar_alteracoes_afins: false,
                        activity_name: '',
                        partners: [
                           {
                                name: '',
                                cpf_cnpj: '',
                                participation: 0
                            }
                        ],
                        monthly_billing: 0
                    },
                    documents: [],
                    proposal: {
                        branch_id: '',
                        lead:0,
                        yn_lead:"Não",
                        team_id: '',
                        salesman_id: '',
                        administrator_id: '',
                        meeting_at: '',
                        first_meeting_at: '',
                        type_group_id: '',
                        group_id: '',
                        quota: '',
                        model: {
                            manufacturer_id: ''
                        },
                        model_id: '',
                        fuel_id: '',
                        plan_id: '',
                        reason_acquisition: '',
                        condition: '',
                        formation: '',
                        administrate_tax: '',
                        life_insurance: '',
                        value: '',
                        plot_amount: '',
                        number_installments: '',
                        media_id: '',
                        physical_proposal: '',
                        type_payment_id: [],
                        sale_at: '',
                        installment_due: '',
                        vehicle_is_new: false,
                        disposal_fee_is_internal: false
                    }
                },
                formations: [
                    {id: 'Local', name: 'Consórcio Local'},
                    {id: 'Nacional', name: 'Consórcio Nacional'}
                ],
                groups: [],
                integer: {
                    decimal: '',
                    thousands: '.',
                    prefix: '',
                    suffix: '',
                    precision: 0,
                    masked: false
                },
                marital_status: [
                    {value: '', text: 'Selecione uma opção'},
                    {value: 'S', text: 'Solteiro'},
                    {value: 'C', text: 'Casado'},
                    {value: 'D', text: 'Divorciado'},
                    {value: 'V', text: 'Viúvo'},
                    {value: 'U', text: 'União Estável'},
                    {value: 'O', text: 'Outros'}
                ],
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                optionPlans: [
                    {id: 'S7', name: 'Plano Simples (67%)'},
                    {id: 'S', name: 'Plano Simples (75%)'},
                    {id: 'I', name: 'Plano Integral (100%)'}
                ],
                percent: {
                    decimal: ',',
                    thousands: '',
                    prefix: '',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                salesman: false,
                salesmans: [],
                sexes: [
                    {value: '', text: 'Selecione uma opção'},
                    {value: 'F', text: 'Feminino'},
                    {value: 'M', text: 'Masculino'},
                ],
                tabIndex: 0,
                type_groups: [
                    {id: 0, name: 'Novo Grupo'},
                    {id: 1, name: 'Grupo em Andamento'}
                ],
                validation: {
                    address: {
                        address: '',
                        cep: '',
                        number: '',
                        complement: '',
                        borough: '',
                        city: {
                            id: '',
                            state: {
                                id: ''
                            }
                        }
                    },
                    client: {
                        cpf_cnpj: '',
                        name: '',
                        registration_number: '',
                        dispatcher_registration_number: '',
                        shipment_date_registration_number: '',
                        nationality: '',
                        marital_status: '',
                        profession: '',
                        sex: '',
                        date_of_birth: '',
                        authorize_disseminate_data: '',
                        mail: '',
                        cell_phone: '',
                        home_phone: '',
                        commercial_phone: ''
                    },
                    proposal: {
                        salesman_id: '',
                        administrator_id: '',
                        meeting_at: '',
                        first_meeting_at: '',
                        group_id: '',
                        quota: '',
                        manufacturer_id: '',
                        model_id: '',
                        type_group_id: '',
                        plan_id: '',
                        option_plan: '',
                        reason_acquisition: '',
                        administrate_tax: '',
                        life_insurance: '',
                        value: '',
                        plot_amount: '',
                        number_installments: '',
                        media_id: '',
                        physical_proposal: '',
                        type_payment_id: '',
                        sale_at: '',
                        deployment_at: '',
                        installment_due: ''
                    }
                }
            };
        },
        created() {
            var self = this;

            self.getDataAdministrators();
        },
        methods: {
            addPartner() {
                var self = this;

                var partner = {
                    name: '',
                    cpf_cnpj: '',
                    participation: 0
                };

                self.form.client.partners.push(partner);
            },
            removePartner(_partner) {
                var self = this;
                self.$dialog
                    .confirm("Deseja realmente remover o sócio?")
                    .then(function () {
                        var partnerIndex = self.form.client.partners.indexOf(_partner);
                        self.form.client.partners.splice(partnerIndex, 1);
                    });
            },
            async checkPhoneLead() {

                if (this.form.client.cell_phone == null || this.form.client.cell_phone == '') {
                    return;
                }

                const params = {phone: this.form.client.cell_phone};

                await this.$store.dispatch('lead/search', params);
                const leads = this.leads.itens[0];
                const teams = this.$store.state.teams.itens;
                const origens = this.$store.state.medias.itens;

                if (leads !== undefined) {
                    this.form.proposal.lead = 1;
                    this.form.proposal.yn_lead = "Sim";
                    let origemFiltered = origens.filter((origem) => {
                        return origem.name == 'Lead'
                    })
                    if (origemFiltered.length == 0) {
                        this.$notify.error("Esse cliente teve origem no Lead mas a mídia \"Lead\" não está cadastrada.");
                        return;
                    }
                   // this.form.proposal.media_id = origemFiltered[0].id
                    this.form.proposal.team_id = '';
                    await this.changeTeam('');
                    this.form.proposal.salesman_id = leads.user.id;
                    this.phoneFromLead = true;

                    this.$notify.warning("Esse cliente teve origem no Lead.");
                } else {
                    this.form.proposal.lead = 0;
                    this.form.proposal.yn_lead = "Não";
                    this.form.proposal.media_id = '';
                    this.form.proposal.team_id = '';
                    this.form.proposal.salesman_id = '';
                    this.phoneFromLead = false;
                }
            },
            checkProtocol() {
              var self = this;
              if (self.form.proposal.administrator_id && self.form.proposal.physical_proposal) {
                const response = self.$store.dispatch('proposals/validProtocol', {
                    administrator_id: self.form.proposal.administrator_id,
                    physical_proposal: self.form.proposal.physical_proposal
                });
                self.validation.proposal.physical_proposal = "";
                self.$root.$emit("onLoading");

                setTimeout(function(){
                    self.$refs["physical_proposal"].focus();
                    self.tabIndex = 0;
                }, 1);

                response.then(function (_response) {
                    self.$root.$emit("onLoading");
                    self.tabIndex = 1;
                });

                response.catch(function (_error) {
                    self.$root.$emit("onLoading");
                    self.validation.proposal.physical_proposal = "Proposta já cadastradda!";
                    self.form.proposal.physical_proposal = '';
                    self.tabIndex = 0;
                });
              }
            },
            setMeetingAt(id){
                this.form.proposal.meeting_at = this.groups[this.groups.findIndex( obj => obj.id == id )].meeting_at.substr(0, 10);
            },
            changeTeam(_teamId) {
                if (_teamId) {
                    this.getDataSalesmans(_teamId);
                    return;
                }
                this.salesmans = this.$store.state.users.itens;
            },
            getBase64(file) {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsBinaryString(file);
                    reader.onload = () => resolve(window.btoa(reader.result));
                    reader.onerror = error => reject(error);
                });
            },
            async getDataAdministrators() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('administrators/all');

                response.then(function () {
                    self.getDataTeams();
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.getDataTeams();
                    self.$root.$emit("onLoading");
                });
            },
            async getDataBanks() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('defaults/banks');

                response.then(function () {
                    self.getDataManufacturers();
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.getDataManufacturers();
                    self.$root.$emit("onLoading");
                });
            },
            async getDataFuels() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('fuels/all');

                response.then(function () {
                    self.$root.$emit("onLoading");
                    self.getDataMedias();
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                    self.getDataMedias();
                });
            },
            async getDataGroups(_administratorId) {
                var self = this;

                self.$root.$emit("onLoading");

                const response = GroupService.getByAdministratorId(_administratorId);

                response.then(function (_groups) {
                    self.groups = _groups;
                    self.$root.$emit("onLoading");

                    self.getDataPlans(_administratorId);
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");

                    self.getDataPlans(_administratorId);
                });
            },
            async getDataManufacturers() {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('manufacturers/all');

                response.then(function () {
                    self.getDataFuels();
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.getDataFuels();
                    self.$root.$emit('onLoading');
                });
            },
            async getDataMedias() {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('medias/all');

                response.then(function () {
                    self.getDataTypeOfPayments();
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.getDataTypeOfPayments();
                    self.$root.$emit('onLoading');
                });
            },
            async getDataModels(_manufacturerId) {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('models/search', 'manufacturer_id=' + _manufacturerId);

                response.then(function () {
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            },
            async getDataPlans(_administratorId) {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('plans/all', _administratorId);

                response.then(function () {
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            },
            async getDataSalesmans(_teamId) {
                var self = this;

                self.$root.$emit("onLoading");

                var params = 'team_id=' + _teamId;

                const response = UserService.all(params);

                response.then(function (_users) {
                    self.salesmans = _users;
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
            async getDataStates() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('defaults/states');

                response.then(function () {
                    if (self.$store.state.defaults.banks.length === 0) {
                        self.getDataBanks();
                    }
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    if (self.$store.state.defaults.banks.length === 0) {
                        self.getDataBanks();
                    }
                    self.$root.$emit("onLoading");
                });
            },
            async getDataTeams() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('teams/all');

                response.then(function () {
                    self.$root.$emit("onLoading");

                    if (self.$store.state.defaults.states.length === 0) {
                        self.getDataStates();
                    } else if (self.$store.state.defaults.banks.length === 0) {
                        self.getDataBanks();
                    }
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");

                    if (self.$store.state.defaults.states.length === 0) {
                        self.getDataStates();
                    } else if (self.$store.state.defaults.banks.length === 0) {
                        self.getDataBanks();
                    }
                });
            },
            async getDataTypeOfPayments() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('type_of_payments/all');

                response.then(function () {
                    self.getTypeSales();
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
            async getTypeSales() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('type_sales/all');

                response.then(function () {
                    self.getUsers();
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
            async getUsers() {
                var self = this;

                self.$root.$emit('onLoading');

                const response = self.$store.dispatch('users/all');

                response.then(function () {
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            },
            loadGroups() {
                var self = this;
                self.administrator = null;
                if (self.form.proposal.administrator_id != '') {
                    self.getDataGroups(this.form.proposal.administrator_id);

                    var administrator = self.$store.state.administrators.itens.find(administrator => administrator.id == self.form.proposal.administrator_id);
                    if (administrator) {
                        self.administrator = administrator.name;
                    }
                }
            },
            onSelectState(_index) {
                this.cities = this.states[_index - 1].cities;
            },
            onSubmit(_ev) {
                _ev.preventDefault();
                var valid = true;
                var self = this;
                var form = self.form;

                if (!self.validateBase()) {
                    self.tabIndex = 0;
                    return false;
                }

                if (!self.validateClient()) {
                    self.tabIndex = 1;
                    return false;
                }

                if (!self.validateProposal()) {
                    self.tabIndex = 2;
                    return false;
                }

                form.documents = self.documents;

                self.$root.$emit("onLoading");

                form.proposal.branch_id = JwtService.getBranchId();
                const response = self.$store.dispatch('proposals/add', form);

                response.then(function () {
                    self.$root.$emit("onLoading");
                    self.$notify.success("Proposta criada com sucesso!");
                    self.$router.push({'name': 'proposals.index'});
                });

                response.catch(function (err) {
                    self.$root.$emit("onLoading");
                    if (err.status === 406 || err.status === 422) {
                        if (err.data.name !== undefined) {
                            self.validation.name = err.data.name[0];
                        }
                        if (err.data.address !== undefined) {
                            if (err.data.address.address !== undefined) {
                                self.validation.address.address = err.data.address.address[0];
                            }
                            if (err.data.address.borough !== undefined) {
                                self.validation.address.borough = err.data.address.borough[0];
                            }
                            if (err.data.address.cep !== undefined) {
                                self.validation.address.cep = err.data.address.cep[0];
                            }
                            if (err.data.address.city_id !== undefined) {
                                self.validation.address.city_id = err.data.address.city_id[0];
                            }
                        }
                    }
                });
            },
            removeFile(_indexFile) {
                this.files.splice(_indexFile, 1);
            },
            searchCep(_ev) {
                _ev.preventDefault();

                var self = this;
                var address = self.form.address;

                var cep = address.cep.replace(/\D/g, '');

                if (cep.length < 8) {
                    return false;
                }

                self.$root.$emit("onLoading");

                const response = DefaultService.searchCep(cep);

                response.then(function (_response) {
                    self.$root.$emit("onLoading");

                    if (_response.resultado > 0) {
                        var states = self.states;

                        var index = (self.states.findIndex(states => states.id == _response.state_id) + 1);

                        self.onSelectState(index);

                        self.form.address.city.state.id = _response.state_id;

                        self.form.address.city.id = _response.city_id;

                        self.form.address.borough = _response.bairro;

                        self.form.address.address = _response.tipo_logradouro + " " + _response.logradouro;
                    } else {
                        self.$notify.error("Esse CEP não existe. Cadastrar o endereço manualmente!");
                    }
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
            searchCpfCnpj(_ev) {
                _ev.preventDefault();

                var self = this;

                var client = self.form.client;

                client.authorize_disseminate_data = false;

                var cpfCnpj = client.cpf_cnpj + "";

                cpfCnpj = cpfCnpj.replace(/\D/g, '') + "";

                if (cpfCnpj.length < 11) {
                    return false;
                }

                const clients = ClientService.get({
                    cpf_cnpj: cpfCnpj
                });

                self.$root.$emit("onLoading");

                clients.then(function (_client) {
                    self.$root.$emit("onLoading");

                    if (_client.length > 0) {
                        self.form.client = _client[0];

                        var addresses = self.form.client.addresses;

                        if (addresses.length > 0) {
                            var index = (self.states.findIndex(states => states.id == addresses[0].city.state_id) + 1);

                            self.onSelectState(index);

                            self.form.address = addresses[0];
                        }
                    } else {
                        self.form.client.name = '';
                        self.form.client.registration_number = '';
                        self.form.client.dispatcher_registration_number = '';
                        self.form.client.shipment_date_registration_number = new Date();
                        self.form.client.date_of_birth = new Date();
                        self.form.client.nationality = '';
                        self.form.client.profession = '';
                        self.form.client.marital_status = 'S';
                        self.form.client.sex = 'M';
                        self.form.client.authorize_disseminate_data = false;
                        self.form.client.mail = null;
                        self.form.client.cell_phone = '';
                        self.form.client.home_phone = '';
                        self.form.client.commercial_phone = '';
                        self.form.client.bank = {
                            id: null,
                            name: ''
                        };
                        self.form.client.bank_branch = 0;
                        self.form.client.bank_digit_branch = 0;
                        self.form.client.account_number = 0;
                        self.form.client.account_digit = 0;
                    }
                });

                clients.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
            validateAddress() {
                var self = this;
                var form = self.form.address;
                var validation = self.validation.address;
                var valid = true;

                validation.cep = "";
                validation.address = "";

                if (form.cep === "") {
                    validation.cep = "Campo obrigatório!";
                    valid = false;
                }


                if (form.borough === "") {
                    validation.borough = "Campo obrigatório!";
                    valid = false;
                }

                if (form.city.state.id === "") {
                    validation.city.state.id = "Campo obrigatório!";
                    valid = false;
                }

                if (form.city.id === "") {
                    validation.city.id = "Campo obrigatório!";
                    valid = false;
                }

                return valid;
            },
            validateBase() {
                var self = this;
                var form = self.form.proposal;
                var validation = self.validation.proposal;
                var valid = true;

                validation.administrator_id = "";
                validation.physical_proposal = "";

                if (form.administrator_id === "") {
                    validation.administrator_id = "Campo obrigatório!";
                    valid = false;
                }

                if (form.physical_proposal === "") {
                    validation.physical_proposal = "Campo obrigatório!";
                    valid = false;
                }

                return valid;
            },
            validateClient() {
                var self = this;
                var form = self.form.client;
                var validation = self.validation.client;
                var valid = true;

                validation.cpf_cnpj = "";
                validation.name = "";
                validation.mail = "";
                validation.registration_number = "";
                validation.cell_phone = "";
                validation.home_phone = "";
                validation.commercial_phone = "";
                validation.dispatcher_registration_number = "";
                validation.shipment_date_registration_number = "";

                if (form.cpf_cnpj === "") {
                    validation.cpf_cnpj = "Campo obrigatório!";
                    valid = false;
                } else {
                    if (form.cpf_cnpj.length === 11) {
                        if (!Validation.cpf(form.cpf_cnpj)) {
                            validation.cpf_cnpj = "CPF inválido!";
                            valid = false;
                        }
                    } else if (form.cpf_cnpj.length === 14) {
                        if (!Validation.cnpj(form.cpf_cnpj)) {
                            validation.cpf_cnpj = "CNPJ inválido!";
                            valid = false;
                        }
                    } else {
                        validation.cpf_cnpj = "Campo inválido!";
                        valid = false;
                    }
                }


                if (form.name === "") {
                    validation.name = "Campo obrigatório!";
                    valid = false;
                }
                if (form.mail == null || form.mail.length <= 1) {
                    validation.mail = "Campo obrigatório!";
                } else if (!Validation.mail(form.mail)) {
                    validation.mail = "E-mail inválido!";
                    valid = false;
                }

                if (form.cell_phone == null || form.cell_phone.length <= 1) {
                    validation.cell_phone = "Campo obrigatório!";
                    valid = false;
                } else if (!Validation.phone(form.cell_phone)) {
                    validation.cell_phone = "Telefone celular inválido!";
                    valid = false;
                }

                if (form.home_phone !== null && form.home_phone.length > 0 && !Validation.phone(form.home_phone)) {
                    validation.home_phone = "Telefone residencial inválido!";
                    valid = false;
                }

                if (form.commercial_phone !== null && form.commercial_phone.length > 0 && !Validation.phone(form.commercial_phone)) {
                    validation.commercial_phone = "Telefone comercial inválido!";
                    valid = false;
                }

                if (!self.validateAddress()) {
                    valid = false;
                }

                return valid;
            },
            validateProposal() {
                var self = this;
                var form = self.form.proposal;
                var validation = self.validation.proposal;
                var valid = true;

                validation.salesman_id = "";
                validation.type_group_id = "";
                validation.manufacturer_id = "";
                validation.model_id = "";
                validation.media_id = "";
                validation.plan_id = "";
                validation.sale_at = "";
                validation.physical_proposal = "";
                validation.value = "";
                validation.plot_amount = "";
                validation.number_installments = "";
                validation.type_payment_id = "";
                validation.installment_due = "";

                if (form.physical_proposal === "") {
                    validation.physical_proposal = "Campo obrigatório!";
                    valid = false;
                }

                if (!self.salesman) {
                    if (form.salesman_id === "") {
                        validation.salesman_id = "Campo obrigatório!";
                        valid = false;
                    }
                }


                if (form.type_group_id === "") {
                    validation.type_group_id = "Campo obrigatório!";
                    valid = false;
                }

                if (form.model.manufacturer_id === "") {
                    validation.manufacturer_id = "Campo obrigatório!";
                    valid = false;
                }

                if (form.model_id === "") {
                    validation.model_id = "Campo obrigatório!";
                    valid = false;
                }



                if (form.sale_at === "") {
                    validation.sale_at = "Campo obrigatório!";
                    valid = false;
                }

                if (form.value === 0) {
                    validation.value = "Campo obrigatório!";
                    valid = false;
                }

                if (form.plot_amount === 0) {
                    validation.plot_amount = "Campo obrigatório!";
                    valid = false;
                }

                if (form.number_installments === 0) {
                    validation.number_installments = "Campo obrigatório!";
                    valid = false;
                } else if (form.number_installments > max_number_installments) {
                    validation.number_installments = "Quant. máxima de parcelas é " + max_number_installments;
                    valid = false;
                }

                if (form.type_payment_id.length === 0) {
                    validation.type_payment_id = "Campo obrigatório!";
                    valid = false;
                }

                if (form.installment_due === "") {
                    validation.installment_due = "Campo obrigatório!";
                    valid = false;
                }

                return valid;
            }
        }
    };
</script>
<style scoped>
    .card-title {
        color: #3c4858;
        text-decoration: none;
    }
    #type_of_payments{
        padding-top: 8px;
    }
</style>
